import { getErrorRes, getSuccessRes } from "../helpers/api-response";
import { handleErrorMessage } from "../helpers/handle-error-message";
import logger from "../helpers/logger";
import axiosIns from "../common/interceptor/axios-interceptor";

//Terminal Group
//Fetch Terminal Group data
export const fetchTerminalGroupData = async (noCache = false) => {
  try {
    const res = await axiosIns.get(
      `rackstar/terminalgroup?noCache=${noCache}`
    );
    return getSuccessRes(
      res.data || [],
      "Terminal Group data fetched successfully."
    );
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to fetch Terminal Group data.`);
  }
};

//Delete Terminal Group
export const deleteTerminalGroupData = async (id) => {
  try {
    const res = await axiosIns.delete(
      `rackstar/terminalgroup/${id}`
    );
    return getSuccessRes(
      res.data || [],
      "Terminal Group data deleted successfully."
    );
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to delete Terminal Group data.`);
  }
};

// Update an existing Terminal Group entry
export const updateTerminalGroupData = async (id, data, toastId) => {
  try {
    const res = await axiosIns.put(
      `rackstar/terminalgroup/${id}`,
      data
    );
    return getSuccessRes(res.data, "Terminal Group data updated successfully!");
  } catch (error) {
    logger.error("updateTerminalGroupData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to update Terminal Group Data.");
  }
};

//Add a Terminal Group data
export const addTerminalGroupData = async (data, toastId) => {
  try {
    const res = await axiosIns.post(
      `rackstar/terminalgroup`,
      data
    );
    return getSuccessRes(res.data, "Terminal Group data added successfully!");
  } catch (error) {
    logger.error("addTerminalGroupData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to add Terminal Group data.");
  }
};

//Group Terminal Map
//Fetch Group Terminal Map data
export const fetchGroupTerminalMapData = async () => {
  try {
    const res = await axiosIns.get(
      `rackstar/terminalgroupmap`
    );
    return getSuccessRes(
      res.data || [],
      "Group Terminal Map data fetched successfully."
    );
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to fetch Group Terminal Map data.`);
  }
};

//Delete Group Terminal Map
export const deleteGroupTerminalMapData = async (id) => {
  try {
    const res = await axiosIns.delete(
      `rackstar/terminalgroupmap/${id}`
    );
    return getSuccessRes(
      res.data || [],
      "Group Terminal Map data deleted successfully."
    );
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to delete Group Terminal Map data.`);
  }
};

// Update an existing Group Terminal Map entry
export const updateGroupTerminalMapData = async (id, data, toastId) => {
  try {
    const res = await axiosIns.put(
      `rackstar/terminalgroupmap/${id}`,
      data
    );
    return getSuccessRes(
      res.data,
      "Group Terminal Map data updated successfully!"
    );
  } catch (error) {
    logger.error("updateGroupTerminalMapData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to update Group Terminal Map Data.");
  }
};

//Add a Group Terminal Map data
export const addGroupTerminalMapData = async (data, toastId) => {
  try {
    const res = await axiosIns.post(
      `rackstar/terminalgroupmap`,
      data
    );
    return getSuccessRes(
      res.data,
      "Group Terminal Map data added successfully!"
    );
  } catch (error) {
    logger.error("addGroupTerminalMapData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to add Group Terminal Map data.");
  }
};
